<template>
  <transition v-cloak name="modal">
    <v-modal
      :is-open="showModal"
      data-test="personal-assistance-modal"
      modal-class="alt-modal"
      @close="emitHideModal(); resetTitleAndContent();"
    >
      <template #title>
        <h3 v-if="showTitleAndContent" v-html="title" />
      </template>
      <template #content>
        <div v-if="showTitleAndContent">
          <p class="push-down" data-test="quickquote-error-modal-content" v-html="description" />
        </div>
      </template>
      <template #buttons>
        <div>
          <call-me
            :datasource="dataSource"
            @call-me-step-two="hideTitleAndContent()"
            @call-me-close="emitHideModal()"
          />
        </div>
      </template>
    </v-modal>
  </transition>
</template>

<script lang="ts">

import CallMe from '@/components/Feature/CallMe/CallMe.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CallMeModal',
  components: {
    
    CallMe
  },
  props: {
    showModal: {
      type: Boolean,
      default() {
        return false;
      }
    },
    title: {
      type: String,
      default() {
        return '';
      }
    },
    description: {
      type: String,
      default() {
        return '';
      }
    },
    dataSource: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      showTitleAndContent: true
    };
  },
  methods: {
    emitHideModal() {
      this.$emit('hide-personal-assistance-modal', true);
    },
    hideTitleAndContent() {
      this.showTitleAndContent = false;
    },
    resetTitleAndContent() {
      this.showTitleAndContent = true;
    }
  }
});
</script>
